export default `
mutation dadosPessoais(
  $id:String
  $nome:String
  $cpf:String
  $dataNascimento:String
  $telefoneCelular: String
  $origem: String
  $email:String
  $recebimentoInformacoesEmail: Boolean
  $captchaResponse: String
  $fluxoCanal: String
  $uuid: String
  $acc: String
  $ex: String
  $cbt: String
  $go: String
)
{
  dadosPessoaisFCG(
      payload:{
          id:$id,
          vwo: {
            uuid: $uuid,
            acc: $acc,
            ex: $ex,
            cbt: $cbt,
            go: $go,
          },
          dadosPessoais: {
              nome:$nome,
              cpf: $cpf,
              dataNascimento: $dataNascimento,
              telefones: {
                  telefoneCelular: $telefoneCelular
              },
              email: $email,
              recebimentoInformacoesEmail:$recebimentoInformacoesEmail
            },
          origem: $origem,
          captchaResponse: $captchaResponse,
          fluxoCanal: $fluxoCanal
      }
  )
  {
      validatorResponse {
          errors {
              category
              message
          }
      }
      dados {
          id
          situacaoProposta
      }
  }
}`;
